// extracted by mini-css-extract-plugin
var _1 = "SSOTab-module__animatedBackground--CAYdA";
var _2 = "SSOTab-module__content--KpQJ_";
var _3 = "SSOTab-module__idpMetadata--kX2Zl";
var _4 = "SSOTab-module__title--_SQpb";
export { _1 as "animatedBackground", _2 as "content", _3 as "idpMetadata", _4 as "title" }
